export default [
  {
    text: 'Program',
    value: 'network.name',
    width: '24%',
  },
  {
    text: 'Tracking type',
    value: 'network.type.name',
    width: '24%',
  },
  {
    text: 'Platform',
    value: 'country',
    width: '24%',
  },
  {
    text: 'Tag',
    value: 'tag.name',
    sortable: false,
    width: '15%',
  },
  {
    text: 'Status',
    value: 'status',
    width: '285px',
  },
  {
    text: 'Targeted path',
    value: 'targeted_path',
    sortable: false,
    width: '15%',
  },
  {
    align: 'end',
    text: 'Network Advertiser ID',
    value: 'network_advertiser_id',
    sortable: false,
  },
];
